export default __webpack_public_path__ + "static/media/instagram.e8c79068.svg";